import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=4215d191&"
import script from "./Page.js?vue&type=script&lang=js&"
export * from "./Page.js?vue&type=script&lang=js&"
import style0 from "./Page.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/develop.mijnmooiestraat.vlaanderen/pro-develop.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4215d191')) {
      api.createRecord('4215d191', component.options)
    } else {
      api.reload('4215d191', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=4215d191&", function () {
      api.rerender('4215d191', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/transitions/Page/Page.vue"
export default component.exports